import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { selectedPlanAtom } from '../../atoms';

import { PlanSummaryColumns } from './PlanSummaryColumns';

export const OrthodonticsSection = () => {
  const { t } = useLingui();
  const currentPlan = useAtomValue(selectedPlanAtom);
  const ortho = currentPlan?.orthoBenefitSummary;

  const hasOrthoData = !!ortho;
  const remainingBenefits = ortho?.remainingBenefits ?? 0;
  const totalBenefits = ortho?.totalBenefits ?? 0;
  const deductible = ortho?.deductible;
  const remainingDeductible = deductible?.remainingDeductible ?? 0;
  const totalDeductible = deductible?.totalDeductible ?? 0;
  const isDeductibleMet = deductible?.status === 'Met';

  return (
    <PlanSummaryColumns
      benefitsTitle={t`ORTHO BENEFITS REMAINING`}
      remainingBenefits={remainingBenefits}
      totalBenefits={totalBenefits}
      hideBenefitsProgress={remainingBenefits === 0}
      benefitsChip={
        remainingBenefits === 0 && totalBenefits > 0
          ? {
              text: t`Benefits Exhausted`,
              variant: 'error',
              icon: <FontAwesomeIcon icon={faExclamationTriangle} />,
            }
          : undefined
      }
      benefitsNoDataMessage={!hasOrthoData ? t`Data not available` : undefined}
      deductibleTitle={t`ORTHO DEDUCTIBLE REMAINING`}
      remainingDeductible={remainingDeductible}
      totalDeductible={totalDeductible}
      isDeductibleMet={isDeductibleMet}
      noDeductibleMessage={
        !hasOrthoData ? t`Data not available` : t`No deductible`
      }
    />
  );
};
